import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
i18n.use(LanguageDetector).use(initReactI18next).init({
    resources: {
        th: {
            translation: require("./locales/th/translation.json")
        },
        la: {
            translation: require("./locales/la/translation.json")
        },
        en: {
            translation: require("./locales/en/translation.json")
        }
    },
    lng: "th",
    fallbackLng: "th",
    interpolation: {
        escapeValue: false
    }
});
export default i18n;
